import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // NOTE: in the future we can pass in the custom link color if necessary
  //       for now, since it's truncating body text(which is usually black/dark slate)
  //       we can set it to text-slate-900
  static values = {
    maxChars: { type: Number, default: 150 }
  }

  connect() {
    this.fullText = this.element.textContent.trim()
    this.truncatedText = this.fullText.slice(0, this.maxCharsValue).trim()

    this.escapedFullText = this.escapeOuterPTagsOnly(this.fullText)
    this.escapedTruncatedText = this.escapeOuterPTagsOnly(this.truncatedText)

    this.expanded = false

    if (this.fullText.length > this.maxCharsValue) {
      this.showTruncated()
    }
  }

  escapeOuterPTagsOnly(html) {
    return html
      .replace(/^<p>/i, '&lt;p&gt;')
      .replace(/<\/p>$/i, '&lt;/p&gt;')
  }

  showTruncated() {
    this.element.innerHTML = `
      <span class="inline-text">${this.escapedTruncatedText}... </span>
      <a href="#" class="!text-slate-900 read-toggle hover:!text-slate-700" role="button" tabindex="0">More</a>
    `
    this.expanded = false
    this.bindLinkClick()
  }

  showFull() {
    this.element.innerHTML = `
      <span class="inline-text">${this.escapedFullText} </span>
      <a href="#" class="!text-slate-900 read-toggle hover:!text-slate-700" role="button" tabindex="0">Less</a>
    `
    this.expanded = true
    this.bindLinkClick()
  }

  bindLinkClick() {
    const link = this.element.querySelector('.read-toggle')
    if (!link) return

    link.addEventListener('click', (e) => {
      e.preventDefault()
      this.toggle()
    })

    link.addEventListener('keydown', (e) => {
      if (e.key === ' ' || e.key === 'Spacebar' || e.keyCode === 32) {
        e.preventDefault()
        this.toggle()
      }
    })
  }

  toggle() {
    if (this.expanded) {
      this.showTruncated()
    } else {
      this.showFull()
    }
  }
}
